export default "__VITE_ASSET__B2SE823F__"